/**
 * NavbarUserSubmenu.jsx
 * Created by michaelbray on 2/23/18.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

const propTypes = {
    selectProfile: PropTypes.bool,
    selectAccount: PropTypes.bool,
    selectReservations: PropTypes.bool,
    selectFavorites: PropTypes.bool,
    selectLotteries: PropTypes.bool
};

export class NavbarUserSubmenu extends React.Component {
    render() {
        return (
            <div className="rec-navbar-usersubmenu">
                <div className="usa-grid-full relative">
                    <div className="usa-width-one-whole">
                        <nav role="navigation">
                            <ul>
                                <li className={this.props.selectProfile ? "active" : ""}>
                                    <a href="/account/login">Profile</a>
                                </li>
                                <li className={this.props.selectAccount ? "active" : ""}>
                                    <a href="/account/login">Account Settings</a>
                                </li>
                                <li className={this.props.selectReservations ? "active" : ""}>
                                    <a href="/reservations">My Orders</a>
                                </li>
                                <li className={this.props.selectFavorites ? "active" : ""}>
                                    <a href="/account/login">Favorites</a>
                                </li>
                                <li className={this.props.selectLotteries ? "active" : ""}>
                                    <a href="/">Lotteries</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
        );
    }
}

NavbarUserSubmenu.propTypes = propTypes;

function select(state) {
    return {
        profile: state.profile
    };
}

export default connect(select)(NavbarUserSubmenu);
